import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const addFiscalYear = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    // '/api/method/technoerp.services.create_fiscalyear',
    '/api/resource/Fiscal Year',
    body
  );
  return data;
});

export const updateFiscalYear = catchAsync(async (body, id) => {
  const { data } = await axiosInstance.post(
    // '/api/method/technoerp.services.update_fiscalyear',
    `/api/resource/Fiscal Year/${id}`,
    body
  );
  return data;
});

export const getFiscalYear = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    // '/api/method/technoerp.services.get_fiscalyears'
    '/api/resource/Fiscal Year?fields=["name","disabled"]'
  );
  return data;
});
export const getFiscalYearById = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(`/api/resource/Fiscal Year/${id}`);
  return data;
});

export const deleteFiscalYear = catchAsync(async (record) => {
  const { data } = await axiosInstance.delete(
    `/api/resource/Fiscal Year/${record}`
    // `/api/method/technoerp.services.delete_record?record=${record}&document=Fiscal Year`
  );
  return data;
});
